import { Reducer } from "redux-actions";
import { DisplayedGridRows, FinancialTargetReduxState } from "./types";
import { Set } from "immutable";

export interface UpdateSelectedTargetIdsPayload {
    targetIds: Set<string>;
}

export type UpdateDisplayedGridRowsPayload = DisplayedGridRows;

export const toggleFinancialTargetGrid: Reducer<FinancialTargetReduxState, void> = (state) => {
    const { isGridOpen } = state;
    return { ...state, isGridOpen: !isGridOpen };
};

export const updateSelectedTargetIds: Reducer<FinancialTargetReduxState, UpdateSelectedTargetIdsPayload> = (
    state,
    payload,
) => {
    return { ...state, selectedTargetIds: payload.payload.targetIds };
};

export const updateDisplayedGridRows: Reducer<FinancialTargetReduxState, UpdateDisplayedGridRowsPayload> = (
    state,
    action,
) => ({ ...state, displayedRows: action.payload });

export const updateCollapseMode: Reducer<FinancialTargetReduxState, boolean> = (state, action) => {
    return { ...state, isCollapseModeOn: action.payload };
};
